"use client";

import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-control text-ui font-semibold hover:bg-accent hover:text-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-primary-wash data-[state=on]:text-primary [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:ring-ring focus-visible:ring-2 outline-none transition-[color,box-shadow] duration-[var(--motion-fast)] ease-[var(--ease-standard)] aria-invalid:ring-destructive aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline:
          "border border-border-strong bg-card hover:bg-accent hover:text-foreground",
      },
      size: {
        default: "h-[var(--control-height)] px-3 min-w-[var(--control-height)]",
        sm: "h-[var(--control-height-compact)] px-2 min-w-[var(--control-height-compact)]",
        lg: "h-[var(--control-height-large)] px-4 min-w-[var(--control-height-large)]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
